import { render, staticRenderFns } from "./helpVideoMore.vue?vue&type=template&id=b35118d0&scoped=true"
import script from "./helpVideoMore.vue?vue&type=script&lang=js"
export * from "./helpVideoMore.vue?vue&type=script&lang=js"
import style0 from "./helpVideoMore.vue?vue&type=style&index=0&id=b35118d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35118d0",
  null
  
)

export default component.exports